import React from "react";
import "./PaymentStatus.css";

const FailurePage = () => {
  return (
    <div className="payment-status-container payment-failure">
      <h2>❌ Pago Rechazado</h2>
      <p>Lo sentimos, tu pago no pudo procesarse.</p>
      <p>Inténtalo nuevamente o usa otro método de pago.</p>
      <a href="/">Volver al inicio</a>
    </div>
  );
};

export default FailurePage;

